<template>
  <div class="overhead-desktop">
    <vue-draggable-resizable
      :w="getItem.w"
      :h="getItem.h"
      :x="getItem.x"
      :y="getItem.y"
      :key="getItem.i"
      :handles="['br']"
      :parent="true"
      :minw="getItem.minw"
      :minh="getItem.minh"
      :maxw="getItem.maxw"
      :maxh="getItem.maxh"
      class="od-window"
      v-on:dragging="onDrag"
      v-on:resizing="onResize"
      v-on:dragstop="onDragStop"
      v-on:resizestop="onResizeStop"
      v-show="!item.isMinimized"
      :drag-handle="'.drag-handle'"
    >
      <div class="od-window__header">
        <div class="od-window__header-text drag-handle">
          <div
            :class="
              `el-icon od-window__icon
              od-window__icon--${item.childComponent}`
            "
          ></div>
          <div class="od-window__header-textOnly">
            {{ $t(item.childComponent) }}
          </div>
        </div>
        <div class="od-window__header-buttons">
          <div
            class="el-icon app-icon close-window"
            @click="closeWindow(item.i)"
          ></div>
        </div>
      </div>
      <div class="od-window__content">
        <component
          v-bind:is="item.childComponent"
          :datatype="item.datatype"
          :i="item.i"
          :index="item.i"
          :sourcename="item.sourcename"
          :id="item.id"
          :windowId="item.windowId"
          :item="item"
        ></component>
      </div>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import VueDraggableResizable from "vue-draggable-resizable";
import lodashGet from "lodash.get";
import windowsSizes from "@/config/window-sizes";

import ObjectInfo from "@/components/object-info/object-info.vue";

import { generateUUID } from "@/utils";

export default {
  props: ["item"],
  components: {
    ObjectInfo,
    VueDraggableResizable
  },
  data() {
    return {
      draggable: true,
      resizable: true,
      index: 1,
      mode: process.env.ENV
    };
  },
  computed: {
    getItem() {
      return this.$store.getters.getOverheadLayout.find(
        elem => elem.i === this.item.i
      );
    },
    getWindowsList() {
      return this.$store.getters.getWindowsList.filter(
        item => item.windowId !== this.item.windowId
      );
    },
    userId() {
      return this.$store.state.auth.user.user_id || null;
    }
  },
  methods: {
    pushItemToDesktop(item) {
      const ev = event;
      const parent = ev.target.closest(".od-window ");
      const parentPosition = parent.getBoundingClientRect();
      const options = {
        x: parentPosition.x,
        y: parentPosition.y,
        w: parent.clientWidth,
        h: parent.clientHeight,
        title: item.childComponent,
        type: item.childComponent,
        name: this.$route.name,
        windowId: item.windowId,
        tabs: lodashGet(this.item.tabs, "length") ? this.item.tabs : undefined
      };
      this.$store.commit("CLOSE_OVERHEAD_WINDOW", item.i);
      this.$store.commit("ADD_NEW_WINDOW", options);
      this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    },
    closeWindow(i) {
      this.$store.commit("DELETE_WINDOW_CONFIG", this.item.windowId);
      this.$store.commit("CLOSE_OVERHEAD_WINDOW", i);
      this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    },
    onDrag() {
      const windowInStore = this.$store.getters.getOverheadLayout[this.item.i];
      const localWindow = this.$children[0];
      if (windowInStore && windowInStore.isMinimized) {
        localWindow.height = 30;
        localWindow.width = 100;
        windowInStore.w = 100;
        windowInStore.h = 30;
      }
    },
    onResize(left, top, width, height) {
      const config = windowsSizes[this.item.childComponent]
        ? windowsSizes[this.item.childComponent].overheadDesktop
        : windowsSizes.default.overheadDesktop;
      const windowInStore = this.$store.getters.getOverheadLayout[this.item.i];
      const localWindow = this.$children[0];
      if (height > config.maxh && width > config.maxw) {
        localWindow.height = config.maxh;
        localWindow.width = config.maxw;
        windowInStore.w = config.maxw;
        windowInStore.h = config.maxh;
      } else if (height > config.maxh) {
        localWindow.height = config.maxh;
        windowInStore.h = config.maxh;
      } else if (width > config.maxw) {
        localWindow.width = config.maxw;
        windowInStore.w = config.maxw;
      }
    },
    onDragStop(left, top) {
      const windowInStore = this.$store.getters.getOverheadLayout[this.item.i];
      if (windowInStore) {
        windowInStore.x = left;
        windowInStore.y = top;
        this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      }
    },
    onResizeStop(left, top, width, height) {
      const windowInStore = this.$store.getters.getOverheadLayout[this.item.i];
      if (windowInStore) {
        windowInStore.isMinimized = false;
        windowInStore.isMaximized = false;
        windowInStore.x = left;
        windowInStore.y = top;
        windowInStore.w = width;
        windowInStore.h = height;
        this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      }
    }
  },
  mounted() {
    if (!this.getItem.windowId) {
      this.getItem.windowId = generateUUID();
    }
    this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
  },
  updated() {
    const config = this.$store.getters.getSizesConfig || {};
    const itemConfig = config[this.item.childComponent];
    if (!config || !itemConfig) {
      return;
    }
    this.$store.commit("SAVE_ITEM_SIZES", this.item);
  }
};
</script>

<style lang="scss" src="./overhead-window.scss"></style>

<i18n>
{
  "ru": {
    "Map" : "Карта",
    "Map3D" : "3D Карта",
    "MapBI" : "Карта BI",
    "Chart" : "Графики",
    "Modelling": "Моделирование",
    "ModellingTools": "Инструменты моделирования",  
    "Layers": "Слои",
    "Tilelayers": "Базовые слои",
    "Route": "Маршрут",
    "Isocost": "Изокоста",
    "Heatmap": "Тепловые карты",
    "Densitymap": "Карта плотности",
    "Timetravel": "Машина времени",
    "Odmatrix": "Матрица корреспонденций",
    "Geopicker": "Анализ геозоны",
    "undefined": "Свободное окно",
    "newdesktop": "Новая рабочая область",
    "notifications": "Уведомления",
    "information": "Информация о системе",
    "object-info": "Карточка объекта",
    "palette": "Палитра",
    "filter": "Фильтр",
    "DataSourceManager": "Менеджер источников данных",
    "userroles": "Роли и разрешения",
    "tasks": "Активные задачи",
    "tabs": "Общее окно",
    "tab": "Общее окно",
    "TrafficCountsTable": "Результаты замеров"
  },
  "en": {
    "Map3D" : "3D map",
    "MapBI" : "Map BI",
    "Chart" : "Charts",
    "Modelling": "Modelling",
    "ModellingTools": "Modelling Tools",  
    "Layers": "Layers",
    "Tilelayers": "Base layers",
    "Route": "Route",
    "Isocost": "Isocost",
    "Heatmap": "Heatmap",
    "Densitymap": "Densitymap",
    "Timetravel": "Time travel",
    "Odmatrix": "Od matrix",
    "Geopicker": "GeoPicker",
    "undefined": "Empty window",
    "newdesktop": "Create new desktop",
    "notifications": "Notifications",
    "information": "Information",
    "object-info": "Object Info",
    "DataSourceManager": "Datasource manager",
    "userroles": "Users & Roles",
    "tasks": "Active tasks",
    "TrafficCountsTable": "Traffic Counts"
  }
}
</i18n>
